module.exports = __webpack_public_path__ + "img/category_foodie.2068656.png";